import { useTutorProfile } from '@/lib/tutor-profile-context';
import {
  ProfileOverviewCard,
  SubjectsCard,
  ScheduleCard,
  RateCard,
} from './tutor-edit-profile';

export function TutorEditProfilePage() {
  const tutorCtx = useTutorProfile();
  const profile = tutorCtx?.profile ?? null;

  if (!profile) return null;

  return (
    <div className="w-full max-w-3xl space-y-6 py-2">
      <ProfileOverviewCard profile={profile} />
      <SubjectsCard profile={profile} onSaved={(p) => tutorCtx?.updateProfile(p)} />
      <ScheduleCard profile={profile} onSaved={(p) => tutorCtx?.updateProfile(p)} />
      <RateCard profile={profile} onSaved={(p) => tutorCtx?.updateProfile(p)} />
    </div>
  );
}
